import scrollLock from './scrollLock';

window.addEventListener('DOMContentLoaded', () => {
  // Get all "trigger" elements
  const $trigger = Array.prototype.slice.call(
    document.querySelectorAll('.u-trigger'),
    0,
  );

  // Check if there are any navbar burgers
  if ($trigger.length > 0) {
    // Add a click event on each of them
    $trigger.forEach(el => {
      el.addEventListener('click', e => {
        e.preventDefault();
        // Get the target from the "data-target" attribute
        const {
          target,
          triggerClassName: className,
          noSelf,
          lockElm,
        } = el.dataset;
        const targetArr = target.split(',');
        const classNames = className.split(',') ?? ['is-active'];

        targetArr.forEach(t => {
          const $target = document.getElementById(t);
          classNames.forEach(cn => {
            $target.classList.toggle(cn);
          });
        });

        if (!noSelf) {
          classNames.forEach(cn => {
            el.classList.toggle(cn);
          });
        }

        if (lockElm) {
          scrollLock.toggleLock(lockElm);
        }

        // Update aria data if exist
        if (el.hasAttribute('aria-expanded')) {
          const attr = el.getAttribute('aria-expanded');
          const isTrue = attr === 'true';
          el.setAttribute('aria-expanded', !isTrue ? 'true' : 'false');
        }

        // To save the user a click more
        if (targetArr.find(targetName => targetName === 'searchform')) {
          const $target = document.getElementById(target);

          if ($target) {
            const firstInput = $target.querySelector('input');

            firstInput.focus();

            // More UX sugar
            if (firstInput.value.length > 0) {
              firstInput.select();
            }
          }
        }
      });
    });
  }
});
